module.exports = require("express");


/*****************
 ** WEBPACK FOOTER
 ** external "express"
 ** module id = 5
 ** module chunks = 0
 **/